import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8561",
		"data-name": "Path 8561",
		d: "M20,3H19V2a1,1,0,0,0-2,0V3H7V2A1,1,0,0,0,5,2V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3ZM19,21H5a1,1,0,0,1-1-1V8H20V20A1,1,0,0,1,19,21Z",
		transform: "translate(-2 -1)"
	})
});
export { SvgCalendar as ReactComponent };
